import { render, staticRenderFns } from "./absStatist.vue?vue&type=template&id=0f644029&scoped=true&style=height%3A%20100%25%3B&"
import script from "./absStatist.vue?vue&type=script&lang=js&"
export * from "./absStatist.vue?vue&type=script&lang=js&"
import style0 from "./absStatist.vue?vue&type=style&index=0&id=0f644029&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f644029",
  null
  
)

export default component.exports